import IGlobalState from '@/interfaces/IGlobalState';

export default {
  getDrawerActive(state: IGlobalState): boolean {
    return state.drawerActive;
  },
  getPosition(state: IGlobalState): {lat: number, lng: number} {
    return {
      lat: state.position.lat,
      lng: state.position.lng,
    };
  },
  getZoomFactor: (state: IGlobalState): number => state.zoomFactor,
  getContrastActive(state: IGlobalState): boolean {
    return state.contrast;
  },
  getFlipResizeActive(state: IGlobalState): number {
    return state.fontSize;
  },
};
